import React from 'react';

interface ProfilePictureProps {
  userId: string;
  fullName?: string;
  size?: 'sm' | 'md' | 'lg';
  // Keep profilePicture as optional for backward compatibility
  profilePicture?: string;
  profilePictureUrl?: string;
}

const ProfilePicture: React.FC<ProfilePictureProps> = ({
  userId,
  profilePicture,
  profilePictureUrl,
  fullName,
  size = 'md',
}) => {
  // Use profilePictureUrl or fallback to profilePicture for backward compatibility
  const imageUrl = profilePictureUrl || profilePicture;

  // Determine the size class
  const sizeClass = {
    sm: 'h-8 w-8 text-sm',
    md: 'h-12 w-12 text-base',
    lg: 'h-24 w-24 text-4xl',
  }[size];

  return (
    <div className={`${sizeClass} rounded-full overflow-hidden bg-gray-200 flex items-center justify-center`}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={fullName || 'User'}
          className="h-full w-full object-cover"
        />
      ) : (
        <span className="text-gray-500 font-medium">
          {fullName?.charAt(0) || 'U'}
        </span>
      )}
    </div>
  );
};

export default ProfilePicture; 